/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import loading from '../../assets/loading.svg';

import { Container } from './styled';

export default function Loading({ isLoading = false }) {
   if (!isLoading) return <></>;
   return (
      <Container>
         <div />
         <span>
            <img src={loading} />
         </span>
      </Container>
   );
}

Loading.propTypes = {
   isLoading: PropTypes.bool,
};
